import type { MenuNavigation } from '@/models/types';

export const getItemLink = (menuItem: MenuNavigation) => {
  switch (menuItem.linkType) {
    case 'external_link':
    case 'internal_link':
      return menuItem.link ?? '';
    default:
      return `/page/${menuItem.id}`;
  }
};
